import Bookings from '../components/pages/Bookings/Bookings.vue'
import BookingsTable from '../components/pages/Bookings/BookingsTable/BookingsTable.vue'

const BookingsFilter = () => import('../components/pages/Bookings/BookingsFilter')
const BookingsTableHead = () => import('../components/pages/Bookings/BookingsTable/BookingsHeadTable')

export default [
  {
    path: '/bookings',
    component: Bookings,
    children: [
      {
        name: 'bookings',
        path: '',
        components: {
          default: BookingsTable,
          filters: BookingsFilter,
          tableHead: BookingsTableHead
        }
      }
    ]
  }
]
